import { render, staticRenderFns } from "./EditOrderAddressDialog.vue?vue&type=template&id=395ba750&scoped=true"
import script from "./EditOrderAddressDialog.vue?vue&type=script&lang=js"
export * from "./EditOrderAddressDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395ba750",
  null
  
)

export default component.exports